import React, { Component } from 'react';
import SubmitButton from '../_shared/SubmitButton';
import axios from 'axios';
import FormError from '../_shared/forms/FormError';
import { snakeCaseToTitle } from '../../utils/Helpers';
import ReactDOM from 'react-dom';
import FormSelect from '../_shared/forms/FormSelect';
import { SearchableSelect } from '../_shared/forms/FormMultiSelect';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const initialState = {
    dateAs: '',
    type: 'customer',
    invoiceFor: '',
    errors: {},
    loading: false,
};

export default class TestingInvoices extends Component {
    constructor(props) {
        super(props);

        this.state = initialState;
    }

    onSubmit = (e) => {
        e.preventDefault();

        this.setState({
            loading: false,
        });

        if (this.validateForm()) {
            this.setState({
                loading: true,
            });

            var data = new FormData();
            data.append('dateAs', moment(this.state.dateAs).format('YYYY-MM-DD'));
            data.append('invoiceType', this.state.type);
            data.append('invoiceFor', this.state.invoiceFor.value);
            axios({
                url: this.props.url,
                method: 'POST',
                data: data,
                headers: { 'Content-Type': 'multipart/form-data' },
            })
                .then((response) => {
                    toastr.success(response.data.message ?? 'Invoice produced successfully');
                    this.setState(initialState);
                })
                .catch((error) => {
                    toastr.error(error.response.data.message ?? 'Something went wrong');
                    this.setState(initialState);
                });
        }
    };

    validateForm = () => {
        let errors = {};
        const fields = ['dateAs', 'invoiceFor', 'type'];

        fields.map((field) => {
            if (!this.state[field]) {
                errors[field] = `${snakeCaseToTitle(field).replace('id', '')} field is required`;
            }
        });

        this.setState({ errors: errors });

        if (Object.keys(errors).length > 0) {
            toastr.error('Please fill in all required fields');
        }

        return Object.keys(errors).length === 0;
    };

    handleDateChange = (date, name) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        if (moment(date).isValid()) {
            this.setState({ [name]: date, errors: errorsObject });
        } else {
            this.setState({ [name]: date, errors: { ...errorsObject, [name]: 'Invalid date' } });
        }
    };

    render() {
        return (
            <form onSubmit={this.onSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <h4 className="text-center">Produce a Periodic Invoice</h4>
                        <p>
                            This will produce an invoice as of the date specified, for either customer or producer. The
                            date must fall within the invoicing period. Running this will have no effect if the invoice
                            for this period already exists; it can be reproduced or updated via the invoices page.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4">
                        <label>Invoice as of date</label>
                        <DatePicker
                            className={this.state.errors.dateAs ? 'is-invalid form-control' : 'form-control'}
                            placeholderText="Invoice as of date"
                            onChange={(date) => this.handleDateChange(date, 'dateAs')}
                            dateFormat="dd/MM/yyyy"
                            selected={this.state.dateAs}
                        />
                        {this.state.errors.dateAs ? <FormError error={this.state.errors.dateAs} /> : ''}
                    </div>
                    <div className="form-group col-md-4">
                        <FormSelect
                            options={['customer', 'provider']}
                            value={this.state.type}
                            label="Invoice type"
                            handleChange={(e) =>
                                this.setState({ type: e.target.value, invoiceFor: initialState.invoiceFor })
                            }
                            classes={this.state.errors.type ? 'form-control is-invalid' : 'form-control'}
                        />
                    </div>
                    {this.state.type === 'customer' ? (
                        <div className="col-md-4 form-group">
                            <SearchableSelect
                                id="CustomerSelect"
                                label="Customer"
                                options={this.props.customers}
                                value={this.state.invoiceFor}
                                handleChange={(invoiceFor) => this.setState({ invoiceFor })}
                            />
                        </div>
                    ) : (
                        <div className="col-md-4 form-group">
                            <SearchableSelect
                                name="ProviderSelect"
                                label="Provider"
                                options={this.props.providers}
                                value={this.state.invoiceFor}
                                handleChange={(invoiceFor) => this.setState({ invoiceFor })}
                            />
                        </div>
                    )}
                </div>
                <div className="row">
                    <div className="col-md-4 form-group">
                        <SubmitButton
                            buttonText={'Produce invoice'}
                            loading={this.state.loading}
                            style={{ width: 200 }}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

if (document.getElementById('testing-invoices')) {
    let element = document.getElementById('testing-invoices');
    let customers = element.dataset.customers ? JSON.parse(element.dataset.customers) : false;
    let providers = element.dataset.providers ? JSON.parse(element.dataset.providers) : false;

    ReactDOM.render(<TestingInvoices url={element.dataset.url} customers={customers} providers={providers} />, element);
}
